import dayjs from 'dayjs';

export const formatDate = (date: Date | string, format = 'YYYY-MM-DD'): string =>
	dayjs(date).format(format);

export const getDateIn1Year = () => {
	return dayjs().add(1, 'year').toDate();
};

export const getYear = () => {
	return dayjs().year();
};
